export default __webpack_public_path__ + "8671d7f64a903b227aaee962a1ed420a.png";